export function Container(props: { children: React.ReactNode }) {
  return (
    <div className="w-full max-w-screen-2xl mx-auto px-4 sm:px-8 py-6 sm:py-10">
      {props?.children}
    </div>
  );
}
